import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import ReactPaginate from 'react-paginate';
import { BASEURL } from '../Config';
import Footer from '../components/Footer';
import Sidebar from '../components/Sidebar';
import Topbar from '../components/Topbar';
import { getBookInfo, getClassInfo } from '../modules/actions';
import { useDispatch } from 'react-redux';
import { useHistory, NavLink } from 'react-router-dom';
import swal from 'sweetalert';
import CustomPagination from "../components/common/CustomPagination";
import ActionBar from "../components/common/ActionBar";

const Classes = () => {
    const [data, setData] = useState([]);
    const [offset, setOffset] = useState(0);
    const [slice, setSlice] = useState([]);
    const [perPage, setPerPage] = useState(5);
    const countPage = useRef(0);
    const [currentPage, setCurrentPage] = useState(0);
    const [pageCount, setPageCount] = useState(0);
    const [editableRow, setEditableRow] = useState(null);
    const [name, setName] = useState("");
    const [classno, setClassno] = useState(0);
    const [subject, setSubject] = useState("");
    const [id, setId] = useState("");
    const [subjects, setSubjects] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [searchData, setSearchData] = useState([]);
    const [dataSearched, setDataSearched] = useState(false);
    const [noResults, setNoResults] = useState(false);

    const dispatch = useDispatch();
    const history = useHistory();

    const receivedData = () => {
        axios.get(`${BASEURL}/api/v1/elp/classes/fetch-all`)
            .then(res => {
                const filteredData = res.data.filter(book => !book.isDeleted);
                const slice = filteredData.slice(offset, offset + perPage);
                //console.log('slice', slice)
                setData(filteredData);
                setPageCount(Math.ceil(filteredData.length / perPage));
                setSlice(slice);
            });
    };

    const sliceData = (newOffset) => {
        let updatedSlice;
        let updatedPageCount;
        if (dataSearched && searchData.length > 0) {
            updatedSlice = searchData.slice(newOffset, newOffset + perPage);
            updatedPageCount = Math.ceil(searchData.length / perPage);
        } else {
            //console.log(newOffset, perPage)
            updatedSlice = data.slice(newOffset, newOffset + perPage);
            updatedPageCount = Math.ceil(data.length / perPage);
        }
        //console.log('updatedSlice', updatedSlice)
        setSlice(updatedSlice);
        setPageCount(updatedPageCount);
    };


    const handlePageClick = (e) => {
        const selectedPage = e.selected;
        const newOffset = selectedPage * perPage;
        countPage.current = selectedPage;
        setCurrentPage(selectedPage);
        setOffset(newOffset);
        sliceData(newOffset);
    };

    const handlePerPageChange = (e) => {
        const newPerPage = parseInt(e.target.value);
        setPerPage(newPerPage);
        setOffset(0);
        setCurrentPage(0);
    };

    useEffect(() => {
        sliceData(offset);
    }, [perPage]);

    const handleAddChapters = (bid) => {
        dispatch(getBookInfo(bid));
        history.push({
            pathname: '/addElpChapters',
            state: { bid: bid }
        });
    };

    const handleViewChapters = (bid) => {
        console.log('clas id bid-------------------------', bid)
        dispatch(getClassInfo(bid));
        history.push({
            pathname: '/elpChapters',
            state: { bid: bid }
        });
    };

    useEffect(() => {
        axios.get(`${BASEURL}/api/v1/subjects/fetchall`)
            .then(res => {
                const subjectsList = res.data.map(subject => subject.subject);
                setSubjects(subjectsList);
            });
        receivedData();
    }, []);

    useEffect(() => {
        handleSearch();
    }, [searchTerm]);

    const handleSearch = () => {
        let searchResults = [];
        if (searchTerm !== '') {
            const ids = new Set();
            searchResults = data.filter(item => {
                const isMatch = item.name.toLowerCase().includes(searchTerm.toLowerCase());
                if (isMatch && !ids.has(item._id)) {
                    ids.add(item._id);
                    return true;
                }
                return false;
            });
        }

        if (searchResults.length > 0) {
            const slice = searchResults.slice(0, perPage);
            const pageCount = Math.ceil(searchResults.length / perPage);
            setDataSearched(true);
            setSlice(slice);
            setPageCount(pageCount);
            setSearchData(searchResults);
            setCurrentPage(0);
            setNoResults(false);
        } else {
            setDataSearched(false);
            setCurrentPage(0);
            setPageCount(0);
            if (searchTerm !== '') {
                setNoResults(true);
            } else {
                handleShowAllBooks();
            }
        }
    };

    const handleShowAllBooks = () => {
        const slice = data.slice(0, perPage);
        setPageCount(Math.ceil(data.length / perPage));
        setSlice(slice);
        setSearchTerm('');
        setNoResults(false);
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        if (name === 'name') setName(value);
        if (name === 'classno') setClassno(value);
        if (name === 'subject') setSubject(value);
    };

    const handleOnDeleteBook = (id) => {
        //console.log('id', id)
        swal({
            title: "Are you sure?",
            text: "All the chapters, topics, and questions related to this book will be deleted!",
            icon: "warning",
            buttons: ['No', 'Yes'],
            dangerMode: true,
        }).then(isConfirm => {
            if (isConfirm) {
                axios.delete(`${BASEURL}/api/v1/elp/classes/delete/${id}`)
                    .then(res => {
                        if (res.status === 200) {
                            swal('Success', 'Book deleted successfully', 'success')
                                .then(() => {
                                    window.location.reload();
                                });
                        } else {
                            swal('Error', 'Error in deleting the book', 'error')
                                .then(() => {
                                    window.location.reload();
                                });
                        }
                    });
            }
        });
    };

    return (
        <div id="wrapper">
            <Sidebar act="classes" />
            <div className="content-page">

                {/* Main Content */}
                <div className="content">
                    <Topbar act="Classes" breadcrumbItems={['ELP', 'Classes']} />
                    {/* container */}
                    <div className="container-fluid main-container">
                        <ActionBar
                            addLink="/addClasses"
                            addLabel="Add Classes"
                            onSearchChange={(e) => setSearchTerm(e.target.value)}
                            searchTerm={searchTerm}
                            placeholder="Search Class Name"
                            showFilter={false} // Hide filter button if not needed
                        >
                        </ActionBar>
                        <div className="row">
                            <div className="col-12">
                                <div className="card main-card">
                                    <div className="card-body p-0">

                                        <table className="table table-centered mb-0 mt-2">
                                            <thead>
                                                <tr>
                                                    <th>Name of the Classes</th>
                                                    <th>Actions</th>
                                                </tr>
                                            </thead>
                                            {(noResults || slice.length == 0) ?
                                                <tbody>
                                                    <tr className="text-center">
                                                        <td colSpan={4}>
                                                            No Results Found
                                                        </td>
                                                    </tr>
                                                </tbody>
                                                :
                                                <tbody>
                                                    {slice.length === 0 ? (
                                                        <tr className="text-center">
                                                            <td colSpan={4}>
                                                                No Results Found
                                                            </td>
                                                        </tr>
                                                    ) : (
                                                        <>
                                                            {slice.map((data, idx) => (
                                                                <tr key={data._id}>
                                                                    <td className="table-user" width={'58%'}>
                                                                        {editableRow === idx ?
                                                                            <input type="text" id="bookname" className="form-control"
                                                                                onChange={(e) => handleChange(e, data._id)}
                                                                                name="name" placeholder="Enter Book Name"
                                                                                defaultValue={data.name} disabled={editableRow !== idx} />
                                                                            :
                                                                            <input type="text" id="bookname" className="form-control"
                                                                                onChange={(e) => handleChange(e, data._id)}
                                                                                name="name" placeholder="Enter Book Name"
                                                                                value={data.name} disabled={editableRow !== idx} />
                                                                        }
                                                                    </td>
                                                                    <td>
                                                                        <button className="btn mb-2"
                                                                            onClick={() => { history.push('/editClass/' + data.uuid) }}>
                                                                            <i className="mdi mdi-pencil" />
                                                                        </button>
                                                                        <button className="btn mb-2" onClick={() => handleOnDeleteBook(data.uuid)}> <i className="mdi mdi-delete" /></button>
                                                                        <button className="btn btn-success brn-sm table_Action_btns mb-2"
                                                                            onClick={() => handleAddChapters(data.uuid)}
                                                                        > <i className="mdi mdi-plus-circle" /> Chapters</button>
                                                                        <button className="btn btn-warning brn-sm mb-2"
                                                                            onClick={() => handleViewChapters(data.uuid)}
                                                                        > <i className="mdi mdi-eye-circle" /> Chapters</button>
                                                                    </td>
                                                                </tr>
                                                            ))}
                                                        </>
                                                    )}
                                                </tbody>
                                            }
                                        </table>

                                        <div>
                                            <CustomPagination 
                                                offset={offset}
                                                perPage={perPage}
                                                totalCount={dataSearched ? searchData.length : data.length}
                                                pageCount={pageCount}
                                                currentPage={currentPage}
                                                onPageChange={handlePageClick}
                                                onPerPageChange={handlePerPageChange}
                                                sliceLength={slice.length}
                                                itemLabel="classes"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* End of Main Content */}
                    <Footer />
                </div>
                {/* End of Content Wrapper */}
            </div>
        </div>
    );
};

export default Classes;
